export const slides = [
  {
    id: "m1",
    kicker: "本周焦点 · 科幻新片",
    title: "星际孤旅",
    subtitle: "当最后一束信号消失，归途本身成了答案。",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20space%20scene%2C%20lone%20spacecraft%20drifting%20toward%20a%20giant%20deep%20blue%20planet%2C%20warm%20amber%20rim%20light%20on%20the%20hull%2C%20vast%20dark%20navy%20starfield%2C%20atmospheric%20film%20grain%2C%20no%20text&width=1600&height=900&seq=hero-01&orientation=landscape",
  },
  {
    id: "t1",
    kicker: "热播剧集 · 悬疑",
    title: "长夜将明",
    subtitle: "十六年前的证词，在同一个夜里改了口。",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20night%20scene%2C%20rainy%20city%20alley%20with%20a%20single%20warm%20street%20lamp%2C%20deep%20navy%20blue%20shadows%20and%20wet%20reflections%2C%20moody%20crime%20drama%20atmosphere%2C%20no%20text&width=1600&height=900&seq=hero-02&orientation=landscape",
  },
  {
    id: "t2",
    kicker: "古装大剧 · 权谋",
    title: "春山书院",
    subtitle: "一纸课业，往往决定京城里的一场风雨。",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20scene%20of%20an%20ancient%20Chinese%20academy%20courtyard%20at%20dusk%2C%20warm%20lanterns%20glowing%20under%20wooden%20eaves%2C%20mist%20over%20stone%20steps%2C%20deep%20navy%20and%20amber%20palette%2C%20no%20text&width=1600&height=900&seq=hero-03&orientation=landscape",
  },
  {
    id: "t4",
    kicker: "港味悬疑 · 都市",
    title: "霓虹之下",
    subtitle: "一间洗衣店，装下整条街不愿提起的夜晚。",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20Hong%20Kong%20street%20at%20night%20after%20rain%2C%20warm%20orange%20neon%20signs%20reflected%20in%20puddles%2C%20deep%20navy%20shadows%2C%20moody%20urban%20film%20look%2C%20no%20text&width=1600&height=900&seq=hero-04&orientation=landscape",
  },
];